const interfacePhrases = {
    rate_limited: 'Frequência limitada',
    limit_exceeded: 'Limite excedido',
    used: 'Utilização',
    identifier: 'Identificador',
    verification: 'Verificação',
    messages: 'Mensagens',
    data: 'Dados',
    custom: 'Personalizado',
    management_api: 'API de gestão do {{product}}',
    management_api_role_description: 'Esta função integrada concede acesso à API de gestão.',
    client_credentials: 'Credenciais do cliente',
    authentication_request: 'Pedido de autenticação',
    callback: 'Retorno de autenticação',
    help_title: 'Centro de ajuda iden',
    help_subtitle: 'Ajuda sem sair do seu espaço de trabalho',
    open_help: 'Abrir a página de ajuda completa',
    close_help: 'Fechar ajuda',
    about: 'Sobre e código aberto',
    open_navigation: 'Abrir navegação',
    close_navigation: 'Fechar navegação',
    development_enabled: 'Funcionalidades de desenvolvimento ativadas',
    beta: 'Beta',
    impersonation: 'Representação de utilizador',
    key: 'Chave',
    value: 'Valor',
    error: 'Erro',
    details: 'Detalhes técnicos',
    callback_failed: 'Não foi possível concluir o retorno do início de sessão.',
    back_sign_in: 'Voltar ao início de sessão',
    powered_by: 'Desenvolvido por',
    avatar: 'Avatar',
    logo: 'Logótipo',
    qr_code: 'Código QR',
    sample_title: 'Quer ver um exemplo?',
    sample_description: 'Explore uma aplicação de exemplo que utiliza este guia.',
    sample_action: 'Ver exemplo',
    further_readings: 'Leituras complementares',
    complete_guide: 'Guia completo',
    custom_domains_notice: 'Após adicionar <a>domínios personalizados</a>, pode utilizar este ponto final: <code>{{endpoint}}</code>.',
    my_project: 'O meu projeto',
    my_secret: 'O meu segredo',
    my_token: 'O meu token',
    role_example: 'Leitor',
    reset_retry: 'Repor a configuração e tentar novamente',
    open_dev_panel: 'Abrir painel do programador',
    close_dev_panel: 'Fechar painel do programador',
    configuration: 'Configuração',
    app_id: 'ID da aplicação',
    extra_parameters: 'Parâmetros adicionais de início de sessão',
    prompt: 'Pedido de autenticação',
    scope: 'Âmbito',
    resource: 'Recurso',
    resources_space_delimited: 'Recursos (separados por espaços)',
    sign_out_to_apply: 'Termine a sessão para aplicar as alterações.',
    refresh_token_grant: 'Autorização com token de atualização',
    organization_id: 'ID da organização',
    console_result: 'Veja o resultado na consola do navegador.',
    request_token: 'Pedir token',
    user_info: 'Informações do utilizador',
    get_id_token_claims: 'Obter declarações do token de identidade',
    fetch_user_info: 'Obter informações do utilizador',
    device_initializing: 'A iniciar a autorização do dispositivo…',
    device_success: 'Iniciou sessão na aplicação de demonstração.',
    sign_in_information: 'As suas informações de início de sessão:',
    email: 'E-mail',
    username: 'Nome de utilizador',
    user_id: 'ID do utilizador',
    sign_out_demo: 'Terminar sessão na demonstração',
    device_expired: 'Código do dispositivo expirado',
    generic_error: 'Ocorreu um erro',
    device_expired_description: 'O código do dispositivo expirou. Tente novamente para obter um novo código.',
    sign_in_title: 'Inicie sessão na sua conta',
    scan_instruction: 'Leia o código QR ou abra este endereço noutro dispositivo:',
    one_time_code: 'Introduza o código de utilização única',
    token_info: 'Informações do token',
    get_access_token: 'Obter token de acesso',
    context_unavailable: 'Não foi possível carregar as informações da conta.',
    not_initialized: 'As informações da conta não foram inicializadas.',
    not_set: 'Não definido',
    configured: 'Configurado',
    password: 'Palavra-passe',
    phone: 'Número de telefone',
    search_help: 'Pesquisar ajuda',
    language: 'Idioma',
    menu: 'Menu',
    compatibility_notice: 'Compatibilidade: os nomes herdados de SDKs, pacotes, protocolos, componentes e cabeçalhos de pedidos do Logto permanecem inalterados.',
    source: 'Fonte',
    upstream_repository: 'Repositório de origem',
    current_fork: 'Repositório atual',
    license_notice: 'iden baseia-se no Logto, software de código aberto licenciado sob a Mozilla Public License 2.0.',
    about_description: 'Informações do produto e atribuição de código aberto.',
    page_not_found: 'Página não encontrada',
    page_not_found_description: 'Esta página não está disponível. Volte ao centro de ajuda para continuar.',
    introduction: 'Introdução',
    quick_starts: 'Início rápido',
    integration: 'Integração',
    end_user_flows: 'Fluxos do utilizador final',
    authorization: 'Autorização',
    user_management: 'Gestão de utilizadores',
    security: 'Segurança',
    customization: 'Personalização',
    connectors: 'Conectores',
    organizations: 'Organizações',
    self_hosting: 'Alojamento próprio',
    continue: 'Continuar',
    loading: 'A carregar…',
    save: 'Guardar',
    saved: 'Guardado',
    try_again: 'Tentar novamente',
    client_id: 'ID do cliente',
    client_secret: 'Segredo do cliente',
    redirect_uri: 'URI de redirecionamento',
    status: 'Estado',
    type: 'Tipo',
    permissions: 'Permissões',
    token_data: 'Dados do token',
    context_data: 'Dados de contexto',
    jwt_extra_claims: 'Declarações adicionais do token',
    action_result: 'Resultado da ação',
    social_account_already_linked: 'Esta conta social já está associada.',
};
export default Object.freeze(interfacePhrases);
